import { FetchPortalSettingActionTypes } from '../actions/PortalSettingsActions';
import { handleActions } from 'flux-actions';
import Immutable from 'immutable';
const initialState = Immutable.Map({
  gdprUnsubscribeLinkEnabled: 'false'
});
export default handleActions({
  [FetchPortalSettingActionTypes.SUCCESS](state, action) {
    if (!action.payload) {
      return state;
    }
    const {
      settings
    } = action.payload.data;
    if (settings.length === 0) {
      return state;
    }
    const {
      key,
      value
    } = settings[0];
    return state.set(key, value);
  }
}, initialState);